export default __webpack_public_path__ + "static/media/owolabi.786e7a97.png";